import React, { Component } from 'react'
import { History } from 'history'
import { withRouter } from 'react-router'
import { withCookies, Cookies } from 'react-cookie'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { instanceOf } from 'prop-types'
import cookie from 'react-cookies'
import { trackPromise } from 'react-promise-tracker'

import {
  setHydrationAlert,
  getHydrationAlert,
  patchHydrationAlert,
  getUserData,
  getUserFeed,
  getTrainingDays,
} from '../../Api/backendApi'
import { getAllUserWatchedVideos } from '../../Api/videoApi'

import WaterReminder from './WaterReminder'
import WaterScreen from './WaterScreen'

interface Props {
  push: Function
  history: History
  handleSumbitReminderHoursButton: Function
  cookies: any
}

interface State {
  user: any
  openMenu: boolean
  actualPage: string
  isPlayerActive: boolean
  timeReminder: any
  hourFrom: number | null
  hourTo: number | null
  isWaterReminderChecked: boolean
  waterId: any
  isWaterDataExist: boolean
  isSaveButtonActive: boolean
  userMail: string
  trainingDays: any
  allWatchedVids: []
  activeSubscriptionEndTime: string
  isUserLoggedIn: boolean
  userId: any
  isUserNewsletterSub: boolean
  isDemoAccount: boolean
}

class WaterRedminderContainer extends Component<Props, State> {
  // static propTypes = {
  //   cookies: instanceOf(Cookies).isRequired,
  // }

  // constructor(props: any) {
  //   super(props)
  //   const { cookies } = props
  // }

  // state: State = {
  //   user: null,
  //   openMenu: false,
  //   actualPage: '',
  //   isPlayerActive: false,
  //   timeReminder: {},
  //   hourFrom: null,
  //   hourTo: null,
  //   isWaterReminderChecked: false,
  //   waterId: null,
  //   isWaterDataExist: false,
  //   isSaveButtonActive: false,
  //   userMail: cookie.load('userEmail'),
  //   trainingDays: [],
  //   allWatchedVids: [],
  //   activeSubscriptionEndTime: '12-12-2020',
  //   isUserLoggedIn: cookie.load('accessToken') ? true : false,
  //   userId: 0,
  //   isUserNewsletterSub: false,
  //   isDemoAccount: cookie.load('userDemoMode'),
  // }

  // componentDidMount = async () => {
  //   await this.setUserWaterData()
  //   if (!this.state.isUserLoggedIn || this.state.user.name == '') {
  //     this.props.history.push('/')
  //   }
  // }

  // setUserWaterData = async () => {
  //   if (this.state.user == null) {
  //     let userData: any = await trackPromise(getUserData())
  //     this.setState({
  //       user: userData,
  //       isUserNewsletterSub: userData.is_newsletter_subscriber,
  //     })
  //   }

  //   if (this.state.waterId == null) {
  //     let waterData: any = await trackPromise(getHydrationAlert())
  //     this.setState({
  //       hourFrom: waterData ? waterData.data.start_hour : null,
  //       hourTo: waterData ? waterData.data.end_hour : null,
  //       isWaterReminderChecked: waterData
  //         ? waterData.data.notification_enabled
  //         : false,
  //       waterId: waterData ? waterData.data.id : null,
  //       isWaterDataExist: waterData ? true : false,
  //     })
  //   }
  // }

  // updateUserSubLocalChange = () => {
  //   this.setState({
  //     isUserNewsletterSub: !this.state.isUserNewsletterSub,
  //   })
  // }

  // onOpenMenuClick = () => {
  //   this.setState({
  //     openMenu: !this.state.openMenu,
  //   })
  // }

  // changeLocation = (location: string) => {
  //   this.props.history.push(location)
  // }

  // onSubpageChange = (page: string) => {
  //   this.setState({
  //     actualPage: page,
  //   })
  // }

  // closeMenu = () => {
  //   this.setState({
  //     openMenu: false,
  //   })
  // }

  // handleTimeInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
  //   let hourFrom: string = '0'
  //   let hourTo: string = '0'

  //   const getHours = () => {
  //     if (this.state.timeReminder.from) {
  //       hourFrom = this.state.timeReminder.from.substring(0, 2)
  //       this.setState({
  //         hourFrom: parseInt(hourFrom),
  //       })
  //     }
  //     if (this.state.timeReminder.to) {
  //       hourTo = this.state.timeReminder.to.substring(0, 2)
  //       this.setState({
  //         hourTo: parseInt(hourTo),
  //       })
  //     }
  //   }

  //   await this.setState({
  //     timeReminder: {
  //       ...this.state.timeReminder,
  //       [e.target.dataset.time as any]: e.target.value,
  //     },
  //     isSaveButtonActive: true,
  //   })

  //   await getHours()
  // }

  // checkWaterReminder = () => {
  //   this.setState({
  //     isWaterReminderChecked: !this.state.isWaterReminderChecked,
  //     isSaveButtonActive: true,
  //   })
  // }

  // logout = () => {
  //   const { cookies } = this.props
  //   cookies.remove('accessToken')
  //   cookies.remove('refreshToken')
  //   this.props.history.push('/')
  // }

  // handleSumbitReminderHoursButton = () => {
  //   const { isWaterDataExist } = this.state
  //   if (isWaterDataExist) {
  //     patchHydrationAlert(
  //       this.state.hourFrom,
  //       this.state.hourTo,
  //       this.state.isWaterReminderChecked,
  //       this.state.waterId
  //     )
  //     setTimeout(() => {
  //       this.props.history.go(0)
  //     }, 2000)
  //   } else {
  //     setHydrationAlert(
  //       this.state.hourFrom,
  //       this.state.hourTo,
  //       this.state.isWaterReminderChecked
  //     )
  //     this.setState({
  //       isSaveButtonActive: false,
  //     })
  //     setTimeout(() => {
  //       this.props.history.go(0)
  //     }, 2000)
  //   }
  // }

  render() {
    return (
      // <WaterReminder
      //   openMenu={this.state.openMenu}
      //   onOpenMenuClick={this.onOpenMenuClick}
      //   changeLocation={this.changeLocation}
      //   onSubpageChange={this.onSubpageChange}
      //   isPlayerActive={this.state.isPlayerActive}
      //   closeMenu={this.closeMenu}
      //   handleTimeInputChange={this.handleTimeInputChange}
      //   hourTo={this.state.hourTo}
      //   hourFrom={this.state.hourFrom}
      //   isWaterReminderChecked={this.state.isWaterReminderChecked}
      //   checkWaterReminder={this.checkWaterReminder}
      //   logout={this.logout}
      //   handleSumbitReminderHoursButton={this.handleSumbitReminderHoursButton}
      //   isWaterDataExist={this.state.isWaterDataExist}
      //   isSaveButtonActive={this.state.isSaveButtonActive}
      //   userMail={this.state.userMail}
      //   user={this.state.user}
      //   activeSubscriptionEndTime={this.state.activeSubscriptionEndTime}
      //   userId={this.state.userId}
      //   updateUserSubLocalChange={this.updateUserSubLocalChange}
      //   isUserNewsletterSub={this.state.isUserNewsletterSub}
      //   isDemoAccount={this.state.isDemoAccount}
      // />
      <WaterScreen />
    )
  }
}

export default compose(
  withRouter,
  withCookies,
  connect(null, null)
)(WaterRedminderContainer)
